import { UPDATE_EXCHANGE_RATE } from "./exchangeRateActionTypes";

const initialState = {
	usd: undefined,
};

export default (exchangeRate = initialState, action) => {
	switch (action.type) {
		case UPDATE_EXCHANGE_RATE: {
			return {
				...exchangeRate,
				...action?.exchangeRate,
			};
		}
		default:
			return exchangeRate;
	}
};
